import React from "react";

const square = props => <div className="square" style={props.style} />;

export default square;
